//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    path: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      if (this.path) {
        this.$router.push(this.path)
      }
      this.$emit('click')
    },
  },
}
